import { ModalBody } from '@grupoboticario/flora-react';
import styled from 'styled-components';
import Text from 'styles/typography';

export const Title = styled(Text)`
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  padding: 0 10%;
`;

export const ModalBodyStyled = styled(ModalBody)`
  padding: 8px 49px 50px;

  p {
    text-align: center;
  }
`;

export const Line = styled.div`
  background-color: #c4c4c4;
  height: 0.4px;
  width: 100%;

  margin: 30px 0 20px;
`;

export const DraftClaim = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;

  border-top: 1px solid ${({ theme }) => theme.colors.line};
  margin-top: 30px;
  padding-top: 20px;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.line};
    margin-bottom: 20px;
    padding-bottom: 30px;
  }
`;
export const DraftTitle = styled.div`
  p {
    text-align: left;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    &.subtitle {
      font-size: 12px;
    }
  }
`;

export const DraftActions = styled.div`
  justify-self: flex-end;
  align-self: flex-end;
  margin-top: -4px;
  button {
    font-weight: 500;
    width: 95px;
    height: 32px;
    margin-top: 4px;
    margin-right: 6px;
  }
`;

export const Observation = styled(Text)`
  font-weight: bold;
  font-size: 17px;
  line-height: 20px;
  text-align: center;

  color: ${({ theme }) => theme.colors.error};
`;
